import picture1 from '../assets/home_picture/amazoncloneheader2.jpg'
import picture2 from '../assets/home_picture/amazoncloneheader3.jpg'
import picture3 from '../assets/home_picture/amazoncloneheader4.jpg'
import picture4 from '../assets/home_picture/amazoncloneheader5.jpg'

export const snapple=[picture1,picture2,picture3,picture4]

